// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ("static/js/" + chunkId + "." + {"585":"54d0158b","647":"9d823c28"}[chunkId] + ".chunk.js");